import {
    RaikoBaseContainer, RaikoBreadcrumb, raikoBreadCrumbItemGenerator, RaikoButtonSecondary,
    RaikoFlexFirstChildGrowOne,
    RaikoGridOneColumn
} from "@moeindal/base-raiko-panel-components";
import {RouteHelper} from "../../../route/RouteHelper";
import {useState} from "react";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import TabContext from "@mui/lab/TabContext";
import Box from "@mui/material/Box";
import TabList from "@mui/lab/TabList";
import Tab from "@mui/material/Tab";
import TabPanel from "@mui/lab/TabPanel";
import CampaignBasicInfo from "./CampaignBasicInfo";
import WorkAndBusiness from "../../workAndBusiness/WorkAndBusiness";

export default function CampaignDetails() {


    const {state} = useLocation()
    const {id: campaignId = -1} = useParams()

    const [pageTitle, setPageTitle] = useState(state && state.title ? state.title : RouteHelper.Campaigns.name);
    const [tabSelectedValue, setTabSelectedValue] = useState(CampaignDetailsTabType.BasicInformation.id);

    function handleChangeTab(event, newValue) {
        setTabSelectedValue(newValue)
    }

    const navigate = useNavigate()


    return (
        <>
            <RaikoBaseContainer>
                <RaikoGridOneColumn>
                    <RaikoFlexFirstChildGrowOne>
                        <RaikoBreadcrumb breadCrumbItems={[
                            raikoBreadCrumbItemGenerator(
                                RouteHelper.Tourism.name,
                                ""
                            ),
                            raikoBreadCrumbItemGenerator(
                                RouteHelper.Campaigns.name,
                                RouteHelper.Campaigns.globalUrl
                            ),
                            raikoBreadCrumbItemGenerator(
                                pageTitle,
                                ""
                            ),
                        ]}/>
                        <RaikoButtonSecondary label={"بازگشت"} onClick={_ => {
                            navigate(-1)
                        }}/>
                    </RaikoFlexFirstChildGrowOne>

                    <TabContext value={tabSelectedValue}>
                        <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
                            <TabList onChange={handleChangeTab} id="default-tab-container" variant="scrollable">
                                <Tab
                                    label={CampaignDetailsTabType.BasicInformation.title}
                                    value={CampaignDetailsTabType.BasicInformation.id}/>
                                <Tab
                                    label={CampaignDetailsTabType.Requests.title}
                                    value={CampaignDetailsTabType.Requests.id}/>
                            </TabList>
                        </Box>
                        <TabPanel value={CampaignDetailsTabType.BasicInformation.id}>
                            <CampaignBasicInfo campaignId={campaignId}/>
                        </TabPanel>
                        <TabPanel value={CampaignDetailsTabType.Requests.id}>
                            <WorkAndBusiness campaignId={campaignId}/>
                        </TabPanel>
                    </TabContext>

                </RaikoGridOneColumn>
            </RaikoBaseContainer>

        </>
    )
}
const CampaignDetailsTabType = {
    BasicInformation: {
        id: "basic-information",
        title: "اطلاعات پایه",
    },
    Requests: {
        id: "requests",
        title: "درخواست ها",
    }
}